var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunnyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a90c4c3d-8df3-4eeb-a12d-5f972abbd14f",
    "data-name": "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1265.14 204.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a39119c8-5f14-417d-bfe5-dc6317160f0a{fill:#ff9800;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bd45e1af-0771-40f0-8853-9f46430ad2a3",
    "data-name": "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1a4fb0b-8341-47ee-abb9-4bc3669a9554",
    "data-name": "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af8e3e1b-be54-47e4-8398-edd89ac6d57f",
    "data-name": "path2",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M0,143.69l20.85-24.92c14.42,11.89,29.55,19.45,47.83,19.45,14.43,0,23.13-5.94,23.13-15.32s-5.47-13.74-32.27-20.59C27.27,94,6.43,84.86,6.43,53.08,6.43,24,29.79,4.57,62.54,4.57c23.37,0,43.26,7.32,59.54,20.36L103.75,51.47C89.57,41.63,75.58,35.68,62.06,35.68s-20.6,6.42-20.6,14.17C41.46,60.37,48.31,64,76,71.12c32.51,8.47,50.84,20.36,50.84,48.28,0,31.82-24.28,49.89-58.84,49.89A102,102,0,0,1,0,143.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b615de5c-9fbb-4b9c-871e-ee306058236e",
    "data-name": "path3",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M139.77,123.77V44.38h34.8v68.4c0,16.46,7.76,24.93,21.08,24.93s21.75-8.47,21.75-24.93V44.38h34.79V167.05H217.4V149.64c-8,10.28-18.32,19.69-35.94,19.69-26.32,0-41.69-17.4-41.69-45.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b62542d4-d05a-4fd4-81c2-f5bcea56f7a7",
    "data-name": "path4",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M268.58,44.38h34.8V61.79c8-10.32,18.32-19.69,35.94-19.69C365.64,42.1,381,59.5,381,87.62V167h-34.8V98.61c0-16.46-7.8-24.93-21.08-24.93s-21.75,8.47-21.75,24.93V167h-34.8V44.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a39bb86c-59d9-415c-970f-e40ab7d7cc8d",
    "data-name": "path5",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M398.62,44.38h34.79V61.79c8-10.32,18.33-19.69,35.94-19.69,26.33,0,41.7,17.4,41.7,45.52V167h-34.8V98.61c0-16.46-7.8-24.93-21.08-24.93s-21.76,8.47-21.76,24.93V167H398.62V44.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e66cae51-4613-4ad1-aefe-78178dcac10d",
    "data-name": "path6",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M607.82,44.38H644L596.83,170c-9.38,24.93-19.47,34.34-40.31,34.34a57.31,57.31,0,0,1-30.89-8.47l11.66-25.16c4.57,2.76,10.32,4.8,14.9,4.8,5.94,0,9.18-1.85,12.13-8L516.25,44.42h36.88l27.94,83.52,26.79-83.52,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af19cc47-d282-42f1-a680-0716d2394392",
    "data-name": "path7",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M639.82,150.78l14.9-22.88c13.28,9.61,27.23,14.65,38.69,14.65,10.09,0,14.66-3.66,14.66-9.13V133c0-7.56-11.9-10.08-25.41-14.18-17.19-5-36.65-13-36.65-36.82v-.47c0-24.93,20.13-38.91,44.88-38.91,15.57,0,32.51,5.28,45.79,14.18l-13.28,24c-12.14-7.09-24.27-11.46-33.22-11.46-8.47,0-12.81,3.66-12.81,8.46v.48c0,6.85,11.67,10.08,25,14.65,17.18,5.71,37.08,13.94,37.08,36.38v.48c0,27.21-20.37,39.57-46.93,39.57a86,86,0,0,1-52.69-18.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab05c256-3fee-4a7d-9419-9799be741379",
    "data-name": "path8",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M750.39,0H787V30.87H750.39Zm.91,44.38h34.79V167.05H751.3V44.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8302a8f-cb58-41db-994c-028eac91a1ab",
    "data-name": "path9",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M799.21,105.93v-.47c0-41,26.8-63.4,55.88-63.4,18.56,0,30,8.46,38.22,18.31V0h34.8V167.05h-34.8v-17.6c-8.47,11.45-20.13,19.92-38.22,19.92-28.61,0-55.88-22.4-55.88-63.4m94.57,0v-.47c0-20.36-13.51-33.87-29.75-33.87s-30,13.27-30,33.87v.47c0,20.36,13.75,33.87,30,33.87s29.75-13.51,29.75-33.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b850fc46-3849-453a-aa94-4af79ed7646c",
    "data-name": "path10",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M940.2,106.4v-.47c0-35,24.95-63.83,60.69-63.83,41,0,59.77,31.81,59.77,66.59,0,2.75-.23,5.94-.47,9.13H974.8c3.43,15.79,14.42,24,30,24,11.66,0,20.13-3.67,29.75-12.61l19.94,17.61c-11.47,14.17-27.94,22.87-50.17,22.87-36.88,0-64.11-25.87-64.11-63.4m86.53-10.24c-2-15.55-11.23-26.06-25.88-26.06s-23.8,10.27-26.56,26.06h52.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f8f2e802-3da1-4120-8b2f-e4046e5fb00c",
    "data-name": "path11",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M1265.14,72.65h-53.4l37.79-37.76-17-17-37.75,37.72V2.29h-24V55.64l-37.79-37.72-17,17,37.75,37.76h-53.4v24h53.4L1116,134.4l17,17,37.79-37.76V167h24V113.65l37.75,37.76,17-17-37.79-37.72h53.4v-24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e0c9e698-7e09-4bca-8c94-6fd052bed39e",
    "data-name": "path12",
    className: "a39119c8-5f14-417d-bfe5-dc6317160f0a",
    d: "M1254.5,12.81c1.31,0,2-.62,2-1.56s-.74-1.49-2-1.49h-2.3v3.05Zm-5.11-5.48h5.3c2.68,0,4.6,1.18,4.6,3.74a3.46,3.46,0,0,1-2.49,3.48l2.87,4.11h-3.3l-2.43-3.61h-1.74v3.61h-2.81Zm13.43,5.85v0a8.88,8.88,0,1,0-17.76,0v.06a8.83,8.83,0,0,0,8.88,8.94A8.92,8.92,0,0,0,1262.82,13.18Zm-19.71.07v-.07a10.84,10.84,0,1,1,21.67-.06v.06a10.84,10.84,0,1,1-21.67.07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnyLogo);
export default __webpack_public_path__ + "static/media/sunny-logo.96068fb16b735ab2b601967abd04373e.svg";
export { ForwardRef as ReactComponent };